import { client } from '@global/Api';
import {
  CHECK_FOR_UNAVAILABLE_PRODUCTS,
  CHECK_FOR_UNAVAILABLE_PRODUCTS_TYPE,
} from '@global/requests/checkout';
import { PRODUCT_AVAILABILITY_RULES } from '@global/types/types';
import { OrderItemType } from '@global/utils/orderUtils';
import { RootState, store } from '@global/store/store';

interface UnavailabilityCheckResult {
  unavailableProducts: OrderItemType[];
  countryRestrictedProducts: OrderItemType[];
}

export async function checkForUnavailableProducts(
  country: string
): Promise<UnavailabilityCheckResult> {
  try {
    const { cart } = store.getState() as RootState;

    const { data } = await client.query<CHECK_FOR_UNAVAILABLE_PRODUCTS_TYPE>({
      query: CHECK_FOR_UNAVAILABLE_PRODUCTS,
      variables: { cartId: cart.cartId, country },
    });
    const { result } = data.wIsCartHasUnavailableProducts;

    const unavailableProductsMap = result.data.unavailableProducts.reduce(
      (acc, p) => {
        acc[p.uid] = p.reasons;
        return acc;
      },
      {}
    );

    const unavailableProducts = cart.orderItems.filter(
      ({ uid }) => unavailableProductsMap[uid]
    );

    const countryRestrictedProducts = cart.orderItems.filter(({ uid }) => {
      const reasons = unavailableProductsMap[uid] || [];
      return reasons.includes(PRODUCT_AVAILABILITY_RULES.RestrictedCountries);
    });

    return { unavailableProducts, countryRestrictedProducts };
  } catch (error) {
    console.error(error);
    return { unavailableProducts: [], countryRestrictedProducts: [] };
  }
}
